export default function CTA() {
  return (
    <section className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-6xl lg:text-7xl font-bold text-black mb-6 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
            Ready to plan your<br />perfect family journey?
          </h2>
          <p className="text-xl text-gray-500 max-w-3xl mx-auto mb-12 font-light">
            Speak with our travel advisors today and discover accommodations tailored to your needs
          </p>
          <button 
            onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
            className="px-12 py-5 bg-[#3A2F2B] text-white rounded-full text-lg font-semibold hover:bg-[#2A1F1B] transition-all shadow-lg hover:shadow-xl hover:scale-105 flex items-center gap-3 mx-auto whitespace-nowrap cursor-pointer"
          >
            Get Started
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
        </div>

        <div className="relative overflow-hidden mt-20">
          <div className="flex gap-4 animate-scroll">
            <div className="flex-shrink-0 w-80 h-64 rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/51b1d8be3cdb566f49d9b1e3ae1c9bbe.jpg"
                alt="Luxury Hotel Lobby"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="flex-shrink-0 w-80 h-64 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20family%20hotel%20suite%20bedroom%20with%20comfortable%20king%20bed%2C%20elegant%20furnishings%2C%20warm%20neutral%20tones%2C%20natural%20lighting%2C%20contemporary%20Middle%20Eastern%20design%20elements%2C%20spacious%20and%20inviting%2C%20high-end%20hospitality%20photography&width=600&height=500&seq=family-suite-002&orientation=landscape"
                alt="Family Suite"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="flex-shrink-0 w-80 h-64 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Traditional%20heritage%20hotel%20courtyard%20in%20Middle%20East%20with%20authentic%20Islamic%20architecture%2C%20ornate%20details%2C%20fountain%20centerpiece%2C%20warm%20sandstone%20colors%2C%20cultural%20authenticity%2C%20peaceful%20atmosphere%2C%20professional%20travel%20photography&width=600&height=500&seq=heritage-property-003&orientation=landscape"
                alt="Heritage Property"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="flex-shrink-0 w-80 h-64 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Contemporary%20apartment%20living%20room%20in%20Middle%20East%20with%20modern%20furnishings%2C%20large%20windows%2C%20city%20views%2C%20comfortable%20seating%2C%20clean%20design%2C%20warm%20lighting%2C%20spacious%20family%20accommodation%2C%20professional%20interior%20photography&width=600&height=500&seq=modern-apartment-004&orientation=landscape"
                alt="Modern Apartment"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="flex-shrink-0 w-80 h-64 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Luxury%20villa%20exterior%20in%20Middle%20East%20with%20private%20pool%2C%20palm%20trees%2C%20contemporary%20architecture%2C%20warm%20sunset%20lighting%2C%20exclusive%20family%20accommodation%2C%20high-end%20resort%20style%2C%20professional%20real%20estate%20photography&width=600&height=500&seq=luxury-villa-005&orientation=landscape"
                alt="Luxury Villa"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="flex-shrink-0 w-80 h-64 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Hotel%20restaurant%20dining%20area%20with%20halal%20cuisine%20setup%2C%20elegant%20table%20settings%2C%20warm%20ambient%20lighting%2C%20contemporary%20Middle%20Eastern%20interior%20design%2C%20family-friendly%20dining%20space%2C%20professional%20hospitality%20photography&width=600&height=500&seq=hotel-dining-006&orientation=landscape"
                alt="Hotel Dining"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll {
          animation: scroll 30s linear infinite;
          width: max-content;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
}
